"use client";

import type { FC, PropsWithChildren, ReactElement } from "react";
import { useRef } from "react";
import { StyleProvider, extractStaticStyle } from "antd-style";
import { useServerInsertedHTML } from "next/navigation";

interface StyleRegistryProps extends PropsWithChildren {}

const styleCache = (
  extractStaticStyle as typeof extractStaticStyle & { cache: unknown }
).cache;

/**
 * 统一管理 antd-style 的服务端样式注入，避免 FOUC。
 */
export const StyleRegistry: FC<StyleRegistryProps> = ({ children }) => {
  const hasInserted = useRef(false);

  useServerInsertedHTML(() => {
    if (hasInserted.current) {
      return;
    }

    hasInserted.current = true;

    // antd-style 提供的静态样式抽取 API，返回带有 style 元素的数组
    const styles = extractStaticStyle() as Array<{ style: ReactElement }>;

    // 仅在首个 server pass 注入样式，确保客户端复用 cache
    return styles.map((item) => item.style);
  });

  return <StyleProvider cache={styleCache}>{children}</StyleProvider>;
};
